export default __webpack_public_path__ + "ed9692857de598b8a4cd11de507015db.jpg";